import { useContext, useEffect, useRef } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { UserContext } from "../../Context/Context";
import api from "../../../api/axios";

window.Pusher = Pusher;
Pusher.logToConsole = true;

export function useEcho() {
  const { userData } = useContext(UserContext);
  const { user, token } = userData;
  const echoRef = useRef(null);
  const channelsRef = useRef([]);

  useEffect(() => {
    if (!user) return;

    const isLocalhost = window.location.hostname === "localhost";

    // const echo = new Echo({
    //   broadcaster: "pusher",
    //   key: process.env.REACT_APP_PUSHER_APP_KEY,
    //   cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    //   wsHost: process.env.REACT_APP_HOST_NAME,
    //   wsPort: 6001,
    //   forceTLS: false,
    //   authEndpoint: `${process.env.REACT_APP_BACKEND_HOST}/broadcasting/auth`,
    //   auth: {
    //     headers: {
    //       Authorization: `Bearer ${token}`, // token que guardas en React
    //     },
    //   },
    // });

    console.log(token);
    const echo = new Echo({
      broadcaster: "pusher",
      key: process.env.REACT_APP_PUSHER_APP_KEY,
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
      wsHost: process.env.REACT_APP_HOST_NAME,
      wsPort: isLocalhost ? 6001 : 443,
      wssPort: isLocalhost ? 6001 : 443,
      forceTLS: !isLocalhost,
      encrypted: !isLocalhost,
      enabledTransports: ["ws", "wss"],
      authEndpoint: `${process.env.REACT_APP_BACKEND_HOST}/broadcasting/auth`,
      auth: {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });

    echoRef.current = echo;

    const pusher = echo.connector.pusher;

    // Logs de conexión
    pusher.connection.bind("connected", () =>
      console.log(
        "%c🟢 WebSocket conectado",
        "color: #00c853; font-weight: bold;"
      )
    );
    pusher.connection.bind("disconnected", () =>
      console.warn(
        "%c🔴 WebSocket desconectado",
        "color: #ff9100; font-weight: bold;"
      )
    );
    pusher.connection.bind("error", (err) =>
      console.error(
        "%c🔴 Error WebSocket:",
        "color: #d50000; font-weight: bold;",
        err
      )
    );
    pusher.connection.bind("subscription_error", (err) =>
      console.error(
        "%c🔴 Error de suscripción (Auth falló):",
        "color: #ff1744; font-weight: bold;",
        err
      )
    );

    // Suscribirse al canal del usuario
    const userChannel = echo.private(`user.${user.id}`);
    userChannel.listen("NewNotificationEvent", (e) => {
      console.log("Nueva notificación:", e);
    });
    channelsRef.current.push(userChannel);

    return () => {
      channelsRef.current.forEach((ch) => ch.unsubscribe());
      channelsRef.current = [];
      echoRef.current.disconnect();
      echoRef.current = null;
    };
  }, [user]);

  const subscribePrivateChannel = (channelName, eventName, callback) => {
    if (!echoRef.current) return null;
    const channel = echoRef.current
      .private(channelName)
      .listen(eventName, callback);
    channelsRef.current.push(channel);
    return channel;
  };

  return { subscribePrivateChannel };
}
